export enum CountryCodeEnum {
  UNITED_STATES = 'US',
  BRAZIL = 'BR',
  RUSSIAN = 'RU',
  CHINESE = 'CN',
  HONG_KONG = 'HK',
  TURKEY = 'TR',
}
